import { createSlice } from '@reduxjs/toolkit'

export const loadedSlice = createSlice({
  name: 'loaded',
  initialState: {
    value: false,
  },
  reducers: {
    toggleLoaded: (state, action) => {
      state.value =action.payload
    },
   
  },
})

// Action creators are generated for each case reducer function
export const { toggleLoaded } = loadedSlice.actions

export default loadedSlice.reducer